import { render, staticRenderFns } from "./Candidate_case.vue?vue&type=template&id=577dd83d&scoped=true"
import script from "./Candidate_case.vue?vue&type=script&lang=js"
export * from "./Candidate_case.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577dd83d",
  null
  
)

export default component.exports